export interface RouteItem {
    route_id: number;
    route_short_name: string;
    route_long_name: string;
    route_type: string;
    route_class: string;
}

export interface RouteEntity {
    [id: number]: RouteItem;
}

export interface RoutesByType {
    [type: string]: number[];
}

export interface RoutesState {
    ids: number[];
    dates: string[];
    byDate: { [date: string]: RoutesByType };
    entities: RouteEntity;
    selectedId: number;
    loading?: boolean;
}

export interface RouteDirection {
    trip_short_name: string;
    route_short_name: string;
}

export interface RouteStopState {
    ids: number[];
    entities: StopEntity;
    selectedId?: number;
    loading?: boolean;
}

export interface StopEntity {
    [id: number]: RouteStopItem;
}

export interface RouteStopItem {
    stop_id: number;
    stop_sequence: number;
    stop_name: string;
    stop_lat: string;
    stop_lon: string;
}

export interface RouteDirectionEntity {
    [direction_id: string]: RouteDirection;
}

export interface RouteTripItem {
    departure_time: string;
    stop_sequence: number;
    stop_name: string;
}

export enum RouteType {
    BUS = 'B',
}

export interface RouteSearch {
    key: string | number;
    routeIds: number[];
}

export interface RouteSearchEntity {
    [id: string]: RouteSearch;
}

export interface ResRobotStopLocation {
    id: string;
    extId: string;
    name: string;
    lat: string;
    lon: string;
    weight?: number; // no. of travel connections from stop
    products?: number;

    type?: string;
    routeIdx?: number;
    time?: string;
    date?: string;

    depTime?: string;
    depDate?: string;
}

export interface ResRobotTrip {
    ServiceDays?: [];
    LegList?: { Leg?: ResRobotLeg[] };
    idx?: number;
    tripId: string;
    ctxRecon?: string;
    duration?: string;
}

export interface ResRobotLegProduct {
    name: string;
    num: string;
    catCode: string;
    catOutS?: string;
    catOutL?: string;
    operatorCode?: string;
    operator?: string;
    operatorUrl?: string;
}

export interface ResRobotStopArray {
    Stop: ResRobotStopLocation[];
}

export interface ResRobotServiceDay {
    planningPeriodBegin: string;
    planningPeriodEnd: string;
    sDaysR: string; // "Mo, We"
    sDaysI: string; // "not 5., 7. Apr"
    sDaysB: string;
}

export interface ResRobotLeg {
    Origin: ResRobotStopLocation;
    Destination: ResRobotStopLocation;
    Product?: ResRobotLegProduct;
    Stops?: ResRobotStopArray;
    idx: string;
    name: string;
    type: 'JNY' | 'TRSF' | 'WALK' | 'BIKE';
    duration: string;
    dist?: number;
    transportNumber?: string;
    transportCategory?: string;
    reachable?: boolean;
    direction?: string;
}

export interface ResRobotFetchTrip {
    originId?: number;
    originLat?: number;
    originLng?: number;
    destId?: number;
    destLat?: number;
    destLng?: number;
    date: any;
    priority: number;
}

export interface PlannerStopsState {
    ids: string[];
    byId: { [id: string]: ResRobotStopLocation };
    all: ResRobotStopLocation[];
}

export enum PlannerPriorityType {
    DEPARTURE = 0,
    ARRIVAL = 1,
}
